import { Activity } from 'react-feather';

import styles from './NotFound.module.css';
import { Typography } from '../typography';

export function NotFound({ text }: { text: string }) {
  return (
    <div className={styles.notFound}>
      <Activity data-testid="icon" size={50} />
      <Typography sizes={['h5']}>{text}</Typography>
    </div>
  );
}
